import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () =>
  import(/* webpackChunkName: "4-feat-realtime" */ './RealtimeClient').then((module) => ({
    default: module.RealtimeClient,
  }));

export const LoadableRealtimeClient = lazyLoadOnRender({ loader });
